export const handleResError = (err: any): string => {
  const message: unknown = err?.data?.message
  if (!message) return 'Попробуйте снова'
  else if (typeof message === 'string') return err?.data?.message
  else {
    const firstErrorKey = Object.keys(message)[0]
    return err?.data?.message[firstErrorKey]
  }
}
